export function formatAssistants(assistants) {
  return assistants.map(employee_resource => ({
    id: employee_resource.id,
    text: `${employee_resource.employment_contract.person.first_name} ${employee_resource.employment_contract.person.last_name}`,
  }))
}
